export enum ETimePreference {
  MORNING = 'MORNING',
  NOON = 'NOON',
  AFTERNOON = 'AFTERNOON',
  EVENING = 'EVENING'
}
